var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.SkinComponent, {
    tag: "component",
    attrs: {
      "code": _vm.code
    },
    on: {
      "save": _vm.save
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }